import {
  type CommentConstructorData,
  type Comment,
} from '../../../entities/Comment'
import { type LegacyComment } from '../Chat/Chat'

/**
 * The legacy Chat tree renders `LegacyComment`. These functions adapt the
 * `Comment` entity across that boundary and go away with the component.
 */
export const toLegacyComment = (comment: Comment): LegacyComment => ({
  id: comment.id,
  comment: comment.message,
  submit_date: comment.submittedAt.toISOString(),
  userprofile: {
    id: comment.author.id,
    firstName: comment.author.firstName,
    lastName: comment.author.lastName,
    profile_image: comment.author.profileImage ?? '',
  },
})

export const fromLegacyComment = (
  comment: LegacyComment
): CommentConstructorData => ({
  id: comment.id,
  message: comment.comment,
  submittedAt: comment.submit_date,
  author: {
    id: comment.userprofile.id,
    firstName: comment.userprofile.firstName,
    lastName: comment.userprofile.lastName,
    profileImage: comment.userprofile.profile_image,
  },
})
